module.exports = __webpack_public_path__ + "img/category-title01-m.a6d633c1.png";